// import React, { useState } from "react";
// import QRCode from "qrcode.react";
// import axios from "axios";
// import "./QRCodeGenerator.css";
// import { BaseUrl } from "../shared/BaseUrl";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";

// const QRCodeGenerator = () => {
//   const [text, setText] = useState("https://www.tattqr.com/m");
//   const [qrText, setQrText] = useState("");
//   const [qrCodeURL, setQRCodeURL] = useState("");
//   const token = localStorage.getItem("token");

//   const handleGenerate = async () => {
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/api/qrcode/qrcode`,
//         { text }, // Payload
//         { headers: { Authorization: `Bearer ${token}` } } // Headers with Authorization
//       );
//       // console.log("res is", { response });
//       setQRCodeURL(response.data.qrCodeURL);
//       setQrText(response.data.text);
//     } catch (error) {
//       console.error("Error generating QR code", error);
//       if (error.response.data.status === 400) {
//         toast.error(error.response.data.message, {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//         });
//       }
//     }
//   };

//   return (
//     <div className="qr-code-generator-container">
//       <div className="generator-containers">
//         <input
//           style={{
//             borderRadius: "2rem",
//             borderBottom: "2px solid rgb(243, 181, 98)",
//             borderTop: "2px solid rgb(243, 181, 98)",
//             // border: "2px solid rgb(243, 181, 98)",
//             // width: "100%",
//           }}
//           className="qr-code-generator-input"
//           type="text"
//           placeholder="Copy URL from above and paste here..."
//           value={text}
//           // onChange={(e) => setText(e.target.value)}
//         />
//         <button className="qr-code-generator-button" onClick={handleGenerate}>
//           Generate QR
//         </button>
//         {qrCodeURL && (
//           <div className="qr-code-image-container">
//             {
//               <QRCode
//                 className="qr-code"
//                 value={qrText}
//                 level={"L"}
//                 size={175}
//                 style={{ marginBottom: "1rem" }}
//               />
//             }
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default QRCodeGenerator;

import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "./QRCodeGenerator.css";
import { BaseUrl } from "../shared/BaseUrl";
import { toast } from "react-toastify";
import { Card, Spin } from "antd";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { buildTattooQrUrl, extractQrTagFromText } from "../shared/qrLinks";

const QRCodeGenerator = () => {
  const [text] = useState("https://tq2.ai");
  const [qrText, setQrText] = useState("");
  const [qrCodeURL, setQRCodeURL] = useState("");
  const [loading, setLoading] = useState(false);
  const [updatingQr, setUpdatingQr] = useState(false);
  const [checkingExistingQr, setCheckingExistingQr] = useState(true);
  const [existingQr, setExistingQr] = useState(null);
  const svgQrRef = useRef(null);
  const canvasQrRef = useRef(null);
  const token = localStorage.getItem("token");
  const hasExistingQr = Boolean(
    existingQr && (existingQr._id || existingQr.url || existingQr.qrCodeURL)
  );
  const getApiErrorMessage = (error, fallbackMessage) => {
    return (
      error?.response?.data?.message ||
      error?.message ||
      fallbackMessage
    );
  };

  const tattooQrText = useMemo(() => {
    const tag = extractQrTagFromText(qrText);
    return tag ? buildTattooQrUrl(tag) : qrText;
  }, [qrText]);

  const activeQrText = tattooQrText || qrText;
  const activeQrTag = extractQrTagFromText(activeQrText);
  const qrPayloadLength = activeQrText ? activeQrText.length : 0;

  const handleDownloadSvg = () => {
    const svgElement = svgQrRef.current?.querySelector("svg");
    if (!svgElement || !activeQrText) {
      return;
    }

    const serializedSvg = new XMLSerializer().serializeToString(svgElement);
    const blob = new Blob([serializedSvg], {
      type: "image/svg+xml;charset=utf-8",
    });
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `tattoo-qr-${activeQrTag || "code"}.svg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(downloadUrl);
  };

  const handleDownloadPng = () => {
    const canvas = canvasQrRef.current?.querySelector("canvas");
    if (!canvas || !activeQrText) {
      return;
    }

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const link = document.createElement("a");
    link.href = pngUrl;
    link.download = `tattoo-qr-${activeQrTag || "code"}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const fetchExistingQr = async () => {
      if (!token || token === "null" || token === "undefined") {
        setCheckingExistingQr(false);
        return;
      }

      try {
        const response = await axios.get(`${BaseUrl}/api/qrcode/user/qr`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response?.data?._id) {
          setExistingQr(response.data);
          setQRCodeURL(
            String(response?.data?.url || response?.data?.qrCodeURL || "").trim()
          );
          setQrText(String(response?.data?.text || "").trim());
        } else {
          setExistingQr(null);
        }
      } catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 404) {
          setExistingQr(null);
        } else {
          toast.error(
            getApiErrorMessage(error, "Unable to check existing QR code."),
            {
              position: "top-right",
              autoClose: 3000,
            }
          );
        }
      } finally {
        setCheckingExistingQr(false);
      }
    };

    fetchExistingQr();
  }, [token]);

  const handleGenerate = async () => {
    if (hasExistingQr) {
      return;
    }
    setLoading(true); // Show spinner
    try {
      const response = await axios.post(
        `${BaseUrl}/api/qrcode/qrcode`,
        { text }, // Payload
        { headers: { Authorization: `Bearer ${token}` } } // Headers with Authorization
      );
      // console.log("res is", { response });
      setQRCodeURL(response.data.qrCodeURL);
      setQrText(response.data.text);
      setExistingQr({
        _id: response?.data?._id || "generated",
        url: response?.data?.qrCodeURL || "",
        text: response?.data?.text || "",
      });
      toast.success(response?.data?.message || "QR code generated successfully.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error("Error generating QR code", error);
      toast.error(getApiErrorMessage(error, "Failed to generate QR code."), {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false); // Hide spinner
    }
  };

  const handleUpdateQr = async () => {
    if (!hasExistingQr || checkingExistingQr) {
      return;
    }
    setUpdatingQr(true);
    try {
      const response = await axios.put(
        `${BaseUrl}/api/qrcode/user/qr`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const updatedQr = response?.data?.qrCode || existingQr;
      const updatedQrUrl =
        response?.data?.qrCodeURL ||
        updatedQr?.url ||
        updatedQr?.qrCodeURL ||
        "";
      const updatedQrText = response?.data?.text || updatedQr?.text || "";

      setExistingQr(updatedQr);
      setQRCodeURL(String(updatedQrUrl || "").trim());
      setQrText(String(updatedQrText || "").trim());

      toast.success(response?.data?.message || "QR code updated successfully.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Failed to update QR code."), {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setUpdatingQr(false);
    }
  };

  return (
    <div className="qr-code-generator-container">
      <Card
        title="Generate Your QR Code"
        className="qr-generator-card"
      >
        <input
    
          className="qr-code-generator-input"
          type="text"
          placeholder="Copy URL from above and paste here..."
          value={text}
          // onChange={(e) => setText(e.target.value)}
        />
        {hasExistingQr && (
          <p className="qr-generator-note">
            You already have a QR code. Generation is disabled.
          </p>
        )}
        <div className="qr-generator-actions">
          <button
            className="qr-code-generator-button"
            onClick={handleGenerate}
            disabled={loading || checkingExistingQr || hasExistingQr || updatingQr}
          >
            {checkingExistingQr ? (
              "Checking existing QR..."
            ) : loading ? (
              <Spin
                tip="Generating..."
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "auto",
                }}
              />
            ) : (
              "Generate QR"
            )}
          </button>
          {hasExistingQr && (
            <button
              className="qr-code-generator-button qr-code-generator-button-secondary"
              onClick={handleUpdateQr}
              disabled={updatingQr || loading || checkingExistingQr}
            >
              {updatingQr ? "Updating QR..." : "Update QR"}
            </button>
          )}
        </div>
        {activeQrText && (
          <div className="qr-generator-tattoo-summary">
            <span>Tattoo URL</span>
            <strong>{activeQrText}</strong>
            <small>{qrPayloadLength} characters | Level L | SVG ready</small>
          </div>
        )}
        {(qrCodeURL || activeQrText) && (
          <div className="qr-code-image-container">
            {activeQrText ? (
              <>
                <div ref={svgQrRef} className="qr-generator-svg-preview">
                  <QRCodeSVG
                    className="qr-code"
                    value={activeQrText}
                    level="L"
                    size={320}
                    includeMargin
                  />
                </div>
                <div ref={canvasQrRef} className="qr-generator-hidden-canvas">
                  <QRCodeCanvas
                    value={activeQrText}
                    level="L"
                    size={1200}
                    includeMargin
                  />
                </div>
              </>
            ) : (
              <img
                className="qr-code"
                src={qrCodeURL}
                alt={hasExistingQr ? "Your existing QR code" : "Generated QR code"}
              />
            )}
          </div>
        )}
        {activeQrText && (
          <div className="qr-generator-downloads">
            <button
              type="button"
              className="qr-code-generator-button qr-code-generator-button-secondary"
              onClick={handleDownloadSvg}
            >
              Download SVG
            </button>
            <button
              type="button"
              className="qr-code-generator-button qr-code-generator-button-secondary"
              onClick={handleDownloadPng}
            >
              Download PNG
            </button>
          </div>
        )}
      </Card>
    </div>
  );
};

export default QRCodeGenerator;
